import styles from "./StaffSchedule.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import CopyRight from "../../components/CopyRight/CopyRight";
import { FiEdit2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import StaffTimeTable from "../../components/StaffTimeTable/StaffTimeTable";
import ProfilePhotoAndName from "../../components/ProfilePhotoAndName/ProfilePhotoAndName";

const staffScheduleData = [
  {
    id: "staff1",
    name: "Darshan",
    photo: "https://cdn-icons-png.flaticon.com/512/921/921347.png",
    schedule: [
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
    ],
  },
  {
    id: "staff2",
    name: "Darshan",
    photo: "https://cdn-icons-png.flaticon.com/512/921/921347.png",
    schedule: [
      { subject: "Math", topic: "3D Geometry", time: "3:30 PM to 4:30 PM" },
      ,
      null,
      null,
      null,
      null,
    ],
  },
];
  

function StaffSchedule() {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterDate, setFilterDate] = useState("");
   const navigate = useNavigate();

   const handleAddClick = () => {
     dispatch(openModal("something")); // Replace "something" with your modal ID
   };
  

    const handleEditClick = () => {
      dispatch(openModal("chooseRange"));
    };
    const handleArchiveClick = () => {
      navigate("/view-archived");
    };
      const handlecreateform = () => {
        dispatch(openModal("addSchedule"));
      };

      const getColumnData = (data) => {
        return data.map((staff) => ({
          staffName: (
            <ProfilePhotoAndName name={staff.name} photoUrl={staff.photo} />
          ),
          Monday: staff.schedule[0] ? (
            <StaffTimeTable {...staff.schedule[0]} />
          ) : (
            <div className={styles.addPlaceholder} onClick={handleAddClick}>
              Add
            </div>
          ),
          Tuesday: staff.schedule[1] ? (
            <StaffTimeTable {...staff.schedule[1]} />
          ) : (
            <div className={styles.addPlaceholder}>Add</div>
          ),
          Wednesday: staff.schedule[2] ? (
            <StaffTimeTable {...staff.schedule[2]} />
          ) : (
            <div className={styles.addPlaceholder}>Add</div>
          ),
          Thursday: staff.schedule[3] ? (
            <StaffTimeTable {...staff.schedule[3]} />
          ) : (
            <div className={styles.addPlaceholder}>Add</div>
          ),
          Friday: staff.schedule[4] ? (
            <StaffTimeTable {...staff.schedule[4]} />
          ) : (
            <div className={styles.addPlaceholder}>Add</div>
          ),
        }));
      };

      const displayData = getColumnData(staffScheduleData);


      const headingsData = [
        {
          title: <div className={styles.staffHeading}>Staff Name</div>,
          accessor: "staffName",
        },
        ...["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(
          (day, index) => ({
            title: (
              <div className={styles.columnHeading}>
               
                <div className={styles.dayLabel}>{day}</div>
              </div>
            ),
            accessor: day,
          })
        ),
      ];
      
      
  

  return (
    <div className={styles.main}>
      <div className={styles.background}>
        {/* Top Status Boxes */}
        <div className={styles.rowWrapper}>
          <div className={styles.cardsWrapper}>
            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              Export Schedule
            </button>

            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Add Schedule"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
        </div>

        {/* Filters & Search */}
        <div className={styles.totalstudentcard}>
          <div className={styles.studentsection}>
            <div className={styles.filters}>
              
              <Dropdown label="Staff" options={["02", "03", "04"]} />
              
              <Dropdown label="Rooms" options={["Active", "Completed"]} />
            </div>
          </div>

          {/* Dynamic Table */}
          <div className={styles.dynamicdata}>
            <DynamicTable
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>

          {/* Pagination */}
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default StaffSchedule;
